import { render, staticRenderFns } from "./product-show.vue?vue&type=template&id=ac376830&lang=pug&"
import script from "./product-show.vue?vue&type=script&lang=js&"
export * from "./product-show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "product-show.vue"
export default component.exports